import React, { Suspense } from "react";
import { IDeleteConfirmationModalProps } from "./DeleteConfirmationModal.types";

const DeleteConfirmationModal = React.lazy(
  () => import("./DeleteConfirmationModal"),
);

const LazyLoadedDeleteConfirmationModal = (
  props: IDeleteConfirmationModalProps,
) => {
  const { isOpen } = props;
  if (!isOpen) return null;
  return (
    <Suspense fallback={null}>
      <DeleteConfirmationModal {...props} />
    </Suspense>
  );
};

export default LazyLoadedDeleteConfirmationModal;
